// Visual marker for the active loop section. Ported from
// claude/frosty-rosalind-246edb commit b6101d7.
//
// Maintains the `.is-loop-active` CSS class on exactly one `.rh-section`
// descendant matching the given sectionId. Pure DOM mutation — does not
// read or write app state; orchestrator (main.ts) subscribes to
// state.activeLoopId changes and calls setActive accordingly.

export interface LoopIndicatorHandle {
  setActive(sectionId: string | null): void;
  unmount(): void;
}

export function mountLoopIndicator(host: HTMLElement): LoopIndicatorHandle {
  let currentId: string | null = null;

  function clear() {
    if (!currentId) return;
    const prev = host.querySelector(`[data-section-id="${currentId}"]`);
    prev?.classList.remove('is-loop-active');
    currentId = null;
  }

  return {
    setActive(sectionId) {
      clear();
      if (!sectionId) return;
      const target = host.querySelector(`[data-section-id="${sectionId}"]`);
      if (!target) return;
      target.classList.add('is-loop-active');
      currentId = sectionId;
    },
    unmount() {
      clear();
    },
  };
}
